<template>
    <div>
        <div class="content-caption dashed">
            <span>服务类型</span>
        </div>
        <div class="simple-form">
            <div class="form-group">
                <div class="form-label">
                    <label>服务类型</label>
                </div>
                <div class="form-value ">
                    <el-select v-model="servcTypeId" collapse-tags placeholder="请选择">
                        <el-option v-for="item in servcTypeEnumList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>分类信息</span>
            <a class="swb-btn-link" @click="selectServcCat">选择</a>
        </div>
        <div class="simple-form">
            <div class="form-group">
                <div class="form-value">
                    <div class="row">
                        <table class="custom-tbl" style="width: 100%">
                            <thead class="head">
                            <tr class="row">
                                <th>名称</th>
                                <th>级别</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody class="body" v-for="(servcCat,index) in servcCatList">
                            <tr class="row">
                                <td>{{servcCat.catName}}</td>
                                <td v-if="servcCat.catId3 != null">三级</td>
                                <td v-else-if="servcCat.catId2 != null">二级</td>
                                <td v-else-if="servcCat.catId1 != null">一级</td>
                                <td>
                                    <a class="swb-btn-link" @click="removeServcCat(index)">删除</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot" v-if="servcCatList == null || servcCatList.length <= 0">
                                <tr class="row">
                                    <td colspan="3">
                                        <a class="font-gray">暂无数据</a>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-caption dashed required">
            <span>资质要求</span>
            <a class="swb-btn-link" @click="selectStaffQualiType">选择</a>
        </div>
        <div class="simple-form">
            <div class="form-group">
                <div class="form-value">
                    <div class="row">
                        <table class="custom-tbl" style="width: 100%">
                            <thead class="head">
                            <tr class="row">
                                <th>名称</th>
                                <th>级别</th>
                                <th>是否必须</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody class="body" v-for="(staffQualiType,index) in staffQualiTypeList">
                            <tr class="row">
                                <td>{{staffQualiType.name}}</td>
                                <td>
                                    <el-select placeholder="请选择" v-model="staffQualiType.selectLevel" @change="selectQualiType(staffQualiType)">
                                        <el-option v-for="level in staffQualiType.levelList" :label="level.name" :value="level.value"></el-option>
                                    </el-select>
                                </td>
                                <td>
                                    <el-radio-group v-model="staffQualiType.required" @change="requiredChange">
                                        <el-radio :label="false">否</el-radio>
                                        <el-radio :label="true">是</el-radio>
                                    </el-radio-group>
                                </td>
                                <td>
                                    <a class="swb-btn-link" @click="removeStaffQualiType(index)">删除</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot" v-if="staffQualiTypeList == null || staffQualiTypeList.length <= 0">
                                <tr class="row">
                                    <td colspan="4">
                                        <a class="font-gray">暂无数据</a>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>其他信息</span>
        </div>

        <div class="simple-form">
            <div class="form-group">
                <div class="form-label">
                    <label>备注</label>
                </div>
                <div class="form-value">
                    <textarea class="width-2x" placeholder="请输入" v-model="memo"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openMerchtFusedServcCategSelectDlg } from '../categ/selectDlg'
    import { openStaffQualiTypeDlg } from './selectDlg';

    export default {
        name: 'swb-staff-quali-claim-to-servc-save',
        desc: '服务资质要求-新增',
        props: ['servcType'],
        data: function () {
            return {
                servcCatList: [],
                staffQualiTypeList: [],
                memo: null,
                servcTypeId: null,
                servcTypeEnumList: null,
            }
        },
        created: function () {
            if(!Utils.isNoB(this.servcType)) {
                this.servcTypeId = this.servcType;
            }
            this.servcTypeEnumList = getEnumList('workServcType');
        },
        methods: {
            selectServcCat(){
                let self = this;
                //
                let dlgConfig = {
                    multiSelect: true
                };
                let defaultCheckedItems = Utils.merge([], self.servcCatList);
                openMerchtFusedServcCategSelectDlg(dlgConfig, defaultCheckedItems, function (result) {
                    if(result.type == "info") {
                        let servcCatList = result.data || [];
                        self.servcCatList = Utils.merge([], servcCatList);
                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                });
            },
            removeServcCat(index){
                let self = this;
                self.$confirm('确定删除此分类要求？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    self.servcCatList.removeAt(index);
                }).catch(function () {

                })
            },
            selectStaffQualiType(){
                let self = this;
                let staffQualiTypeList = self.staffQualiTypeList;
                let checkedList = [];
                staffQualiTypeList.forEach(function (qualiType) {
                    checkedList.push({
                        id: qualiType.id,
                        selectLevel: qualiType.checkLevel.value
                    });
                });
                openStaffQualiTypeDlg(checkedList, false, true, "forEngineer", function (result) {
                    console.log(result);
                    result.forEach(function (item) {
                        item.required = false;
                        staffQualiTypeList.push(item);
                    });
                    self.staffQualiTypeList = staffQualiTypeList;
                });
            },
            selectQualiType: function (staffQualiType) {
                let levelList = staffQualiType.levelList;
                levelList.forEach(function (level) {
                    if(level.value == staffQualiType.selectLevel) {
                        staffQualiType.checkLevel = level;
                    }
                });
            },
            requiredChange(){
                this.staffQualiTypeList = Utils.merge([], this.staffQualiTypeList);
            },
            removeStaffQualiType(index){
                let self = this;
                self.$confirm('确定删除此资质要求？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    self.staffQualiTypeList.removeAt(index);
                }).catch(function () {

                })
            },
            getDlgResult(){
                let self = this;
                let result = {};
                let servcCatList = Utils.merge([], this.servcCatList);
                let staffQualiTypeList = Utils.merge([], this.staffQualiTypeList);//必选
                if(staffQualiTypeList.length == 0) {
                    result.type = 'wran';
                    result.message = "要求资质必选";
                    return result;
                }
                let postList = [];
                if(servcCatList.length > 0) {
                    servcCatList.forEach(function (servcCat) {
                        staffQualiTypeList.forEach(function (staffQualiType) {
                            let postItem = {};
                            postItem.servcCatId = servcCat.catId;
                            postItem.servcCatName = servcCat.catName;
                            postItem.servcTypeId = self.servcTypeId;
                            postItem.goodsCatId = -1;
                            postItem.typeId = staffQualiType.id;
                            postItem.typeName = staffQualiType.name;
                            postItem.forEngineer = staffQualiType.forEngineer;
                            postItem.level = staffQualiType.checkLevel.value;
                            postItem.levelName = staffQualiType.checkLevel.name;
                            postItem.required = staffQualiType.required;
                            postItem.memo = self.memo;
                            postList.push(postItem);
                        });
                    });
                } else {
                    staffQualiTypeList.forEach(function (staffQualiType) {
                        let postItem = {};
                        postItem.servcTypeId = self.servcTypeId;
                        postItem.goodsCatId = -1;
                        postItem.typeId = staffQualiType.id;
                        postItem.typeName = staffQualiType.name;
                        postItem.forEngineer = staffQualiType.forEngineer;
                        postItem.level = staffQualiType.checkLevel.value;
                        postItem.levelName = staffQualiType.checkLevel.name;
                        postItem.required = staffQualiType.required;
                        postItem.memo = self.memo;
                        postList.push(postItem);
                    });
                }
                let postData = {};
                postData.servcType = self.servcTypeId;
                postData.postList = postList;
                result.type = 'info';
                result.data = postData;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/quali/StaffQualiClaimToServcSave.vue